import WalletsRoute from "./wallets";
import PointsRoute from "./points";

const Routes = [...WalletsRoute, ...PointsRoute];

export default Routes;
